/**
 * Part of ankecare project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

const articleCarousel = $('.j-article-carousel').owlCarousel({
  items: 1,
  loop: true,
  autoplay: false,
  center: true,
  autoplayTimeout: 10000,
  dots: true,
  nav: false,
  smartSpeed: 750,
  responsive: {
    768: {
      items: 3,
      center: true,
    },
    1200: {
      items: 3,
      center: true,
    }
  }
});
